import { render } from "./PageDefault.vue?vue&type=template&id=95451ef4"
import script from "./PageDefault.vue?vue&type=script&lang=js"
export * from "./PageDefault.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__